/**
 * Measures how long document statuses have gone without changing. A large batch keeps moving and
 * can take much longer than a fixed limit, so only a batch that stops moving counts as stuck.
 */
export function createProcessingStallTimer(maxStallMs: number, now: () => number = Date.now) {
  let lastStatusKey: string | undefined;
  let lastChangeMs = now();

  return {
    record(statuses: readonly (string | undefined)[]) {
      const statusKey = statuses.map((status) => status ?? '').join('|');
      if (statusKey !== lastStatusKey) {
        lastStatusKey = statusKey;
        lastChangeMs = now();
      }
    },
    isStalled() {
      return now() - lastChangeMs > maxStallMs;
    },
  };
}
